import { ReactComponent as IconDotsVertical } from "@/assets/svgs/icon-3dots-vertical.svg";
import { ReactComponent as IconShareData } from "@/assets/svgs/icon-data-sharing.svg";
import { ReactComponent as IconDownload } from "@/assets/svgs/icon-download.svg";
import { ReactComponent as IconPlus } from "@/assets/svgs/icon-plus.svg";
import { ReactComponent as IconSearch } from "@/assets/svgs/icon-search.svg";
import { ReactComponent as IconSettings } from "@/assets/svgs/icon-settings-avatar.svg";
import { ReactComponent as IconUseCase } from "@/assets/svgs/icon-use-case-big.svg";
import { ReactComponent as IconUsers } from "@/assets/svgs/icon-user-filled-big.svg";
import { ReactComponent as IconUser } from "@/assets/svgs/icon-user-round-big.svg";
import InputSuffixIcon from "@/components/InputSuffixIcon";
import Popover from "@/components/Popover";
import Breadcrumbs from "@/componentsDS/Breadcrumbs/index";
import { useBuildex } from "@/hooks/use-buildex/index";
import useOrgData from "@/hooks/use-org-data";
import usePage from "@/hooks/use-page";
import useSystem from "@/hooks/use-sys/index";
import useUseCases from "@/hooks/use-use-cases/index";
import useUserManagement from "@/hooks/use-user-management/index";
import { useLocation, useNavigate } from "@/lib/router-dom/index";
import CONSTANTS from "@/public/locales/en/translation.json";
import api from "@/services/api/participantDashboard.js";
import rem from "@/utils/rem";
import moment from "moment";
import { useEffect, useRef, useState } from "react";

const ParticipantDashboard = () => {
	/*=================================================
		General
	/================================================*/

	const isBuildex = useBuildex();

	const [pageTitle] = useState("Participant Dashboard");
	const constants = CONSTANTS.PARTICIPANT_DASHBOARD;

	const [userSearchValue, setUserSearchValue] = useState("");
	const [userSearchedList, setUserSearchedList] = useState();
	const [userBackupList, setUserBackupList] = useState();


	const filterPopUpStyles = {
		border: "solid 1px #cfd8dc",
		borderRadius: "6px",
		backgroundColor: "white",
		background: "white",
		paddingBottom: rem(15),
		paddingTop: rem(4),
	};

	/*=================================================
		Other
	/================================================*/

	const { goTo } = useNavigate()
	const { currentState } = useLocation()

	const { items: useCaseList, fetch: fetchUseCases } = useUseCases();
	const { itemsUserManagement, fetchUserManagement } = useUserManagement();
	const { items: systemsList, getSysPitstops: fetchSystemsList } = useSystem();
	const { items: orgList, fetch: fetchOrgList } = useOrgData();

	const participantData = currentState?.data

	const getUseCasesByOrg = {
		organizationId: participantData?.id,
	};
	const getUsersByOrg = {
		orgId: participantData?.id,
	};
	const getOrgData = {
		orgId: participantData?.id,
	};

	/*=================================================
	  API
	/================================================*/

	useEffect(() => {
		fetchUseCases(getUseCasesByOrg);
		fetchUserManagement(getUsersByOrg);
		fetchSystemsList(getUseCasesByOrg);
		fetchOrgList(getOrgData.orgId)
	}, []);

	useEffect(() => {
		if (itemsUserManagement && itemsUserManagement.length) {
			let usersList = [];
			itemsUserManagement.map((user) => {
				let userRoles = [];
				user?.role?.map((data) => userRoles.push(data.name));
				let roleData = userRoles.join(`,\u0020`);
				usersList.push({
					email: user.email,
					roles: roleData,
					created: moment(user?.createdAt).utc().format("DD MMM YYYY"),
				});
				return true;
			});
			setUserSearchedList(usersList);
			setUserBackupList(usersList);
		}
	}, [itemsUserManagement]);

	useEffect(() => {
		if (userSearchValue && userSearchValue.length && itemsUserManagement) {
			let userSearchedList = userBackupList?.filter((user) => {
				if (
					user?.email
						?.toLowerCase()
						.includes(userSearchValue.toLowerCase()) ||
					user?.roles
						?.toLowerCase()
						.includes(userSearchValue.toLowerCase()) ||
					user?.created
						?.toLowerCase()
						.includes(userSearchValue.toLowerCase())
				) {
					return true;
				}
				return false;
			});
			setUserSearchedList(userSearchedList);
		}
	}, [userSearchValue]);

	/*=================================================
		Functions and methods
	/================================================*/

	const handleViewAndAddUsers = () => {
		const organizationId = participantData?.id;
		goTo(`/admin/participants/${organizationId}/user-management`, {state: participantData});
	};

	async function handleFileDownload(file) {
		const [error, result] = await api.downloadFileUrl({
			orgID: getUseCasesByOrg.organizationId,
			file: file
		});

		if (error) {
			console.error(error);
		} else {
			fetch(result.downloadUrl).then(response => response.blob())
				.then(blob => {
					const link = document.createElement("a");
					link.href = URL.createObjectURL(blob);
					link.download = file;
					link.click();
				}).catch(console.error);
		}
	}

	const { breadcrumbsItems } = usePage({
		title: pageTitle,
		breadcrumbs: [
			{
				label: '',
				link: `/`,
			},
			{
				label: 'Participants',
				link: '/admin/participants'
			},
			{
				label: `${participantData?.name}`,
				link:''
			}
		],

	});

	const UseCaseRow = ({ useCase }) => {

		const [showPopover, setShowPopover] = useState(false);
		const referenceRef = useRef(null);

		function handleDocumentClick(event) {
			if (!referenceRef.current) {
				return
			}

			if (referenceRef.current.contains(event.target)) {
				return
			}
			setShowPopover(false)
		}

		useEffect(() => {
			document.addEventListener('mousedown', handleDocumentClick)
			return () => {
				document.removeEventListener('mousedown', handleDocumentClick)
			}
		}, [])

		function goToEditPersona(useCaseId) {
			goTo(`/admin/use-cases/${participantData?.id}/${useCaseId}/edit-personas`, participantData)
		}

		function goToViewUseCase(useCaseId) {
			goTo(`/admin/use-cases/${participantData?.id}/${useCaseId}`, {state: participantData})
		}

		return (
			<div key={useCase?.id} className="-card-content">
				<div className="--left-section width-85">
					<div className="--avatar-icon"
						style={{ backgroundImage: `url(${useCase?.image})` }}>
					</div>
					<div className="--title-container">
						<div className="--title">
							{useCase?.name}
						</div>
						<div className="--subtitle">
							{useCase?.personas} {constants.Personas}
							<span className="--subtitle-right">
								{useCase?.dataElements?.length} {constants.data_elements}
							</span>
						</div>
					</div>
				</div>
				<div className="--right-section">
					<div data-testid="popover-btn" className="--status-tag--right icon-cursor"
						onClick={() => setShowPopover(!showPopover)}
						onKeyDown={(e) => {
							if (e.key === 'Enter' || e.key === ' '){
								setShowPopover(!showPopover);
							}
						}}
						tabIndex="0"
						role="button"
						aria-label="Toggle Popover"
					>
						<Popover
							visible={showPopover}
							options={{ modifiers: [{ name: "offset", options: { offset: [0, 10,], }, },], }}
						>
							<Popover.Trigger>
								<IconDotsVertical />
							</Popover.Trigger>
							<Popover.Content>
								<div ref={referenceRef} style={filterPopUpStyles}>
									<p className="popover-content-listitem"
										onClick={() => goToViewUseCase(useCase?.id)}
										onKeyDown={(e) => {
											if (e.key === 'Enter' || e.key === ' '){
												goToViewUseCase(useCase?.id);
											}
										}}
										tabIndex="0"
										role="button"
										aria-label="View Details"
									>
										View Details
									</p>
									<p className="popover-content-listitem"
										onClick={() => goToEditPersona(useCase?.id)}
										onKeyDown={(e) => {
											if (e.key === 'Enter' || e.key === ' '){
												goToEditPersona(useCase?.id);
											}
										}}
										tabIndex="0"
										role="button"
										aria-label="Edit Personas"
									>
										Edit Personas
									</p>
									{/* <p className="popover-content-listitem">Remove from Use Case</p> */}
								</div>
							</Popover.Content>
						</Popover>
					</div>
				</div>
			</div>
		)
	}

	const UseCaseContent = ({ itemData }) => {
		const list = itemData?.filter(item => item?.status === "enrolled").map((useCase, index) => {
			return (
				<UseCaseRow useCase={useCase}
					key={index} />
			);
		})

		return (
			list.length > 0 ? list : <div className='use-cases__list-card--empty'>Participant has not enroled to use case.</div>
		)
	}

	return (
		<>
			<Breadcrumbs breadcrumbItems={breadcrumbsItems} />

			{/* <div
				className="title-header__back go-back-page-link"
				onClick={() => goTo("/admin/participants")}
			>
				<div className="backIcon">
					<IconPrevious />
				</div>
				<div className="title-header__back__text link">
					{constants.Back_to_Participants}
				</div>
			</div> */}

			<div className="participant-dashboard-wrapper">
				<div className="-section">
					{/* Participant details card */}
					<div className="--participant-details-card">
						<div className="logo-header-details">
							<div className="company-logo"
								style={{ backgroundImage: `url(${participantData?.iconUrl})` }}>
							</div>
							<div className="company-title-wrapper">
								<p className="name">{participantData?.name} </p>
								<p className="details">
									#{participantData?.uen},{" "}
									{participantData?.id}, Joined{" "}
									{moment(participantData?.created)
										.utc()
										.format("DD MMM YYYY")}
								</p>
							</div>
						</div>
						<div className="divider-horizontal"></div>
						{!isBuildex && <p className="section-title">{constants.About}</p>}

						{!isBuildex && orgList.dataSharingUrl &&
							<>
								<div className="divider-horizontal"></div>
								<div className="details-card-content">
									<div className="details--left-section">
										<div className="details--avatar-icon">
											<IconShareData />
										</div>
										<div className="details--title-container">
											<div className="details--title">
												{constants.Data_Sharing_Agreement}
											</div>
											{/* <div className="details--subtitle">
												Uploaded 29 Dec 2021
											</div> */}
										</div>
									</div>
									<div className="details--right-section">
										<div data-testid="dataSharing-download" className="details--status-tag--right icon-cursor"
											onClick={() => handleFileDownload(orgList.dataSharingUrl)}
											onKeyDown={(e) => {
												if (e.key === 'Enter' || e.key === ' '){
													handleFileDownload(orgList.dataSharingUrl);
												}
											}}
											tabIndex="0"
											role="button"
											aria-label="Download Data Sharing Agreement"
										>
											<IconDownload />
										</div>
									</div>
								</div>
							</>
						}

						{!isBuildex && orgList.enrolmentQUrl &&
							<>
								<div className="divider-horizontal"></div>
								<div className="details-card-content">
									<div className="details--left-section">
										<div className="details--avatar-icon">
											<IconShareData />
										</div>
										<div className="details--title-container">
											<div className="details--title">
												{constants.Enrolment_Questionnaire}
											</div>
											{/* <div className="details--subtitle">
													Uploaded 29 Dec 2021
												</div> */}
										</div>
									</div>
									<div className="details--right-section">
										<div data-testid="enrolment-download" className="details--status-tag--right icon-cursor"
											onClick={() => handleFileDownload(orgList.enrolmentQUrl)}
											onKeyDown={(e) => {
												if (e.key === 'Enter' || e.key === ' '){
													handleFileDownload(orgList.enrolmentQUrl);
												}
											}}
											tabIndex="0"
											role="button"
											aria-label="Download Enrolment Questionnaire"
										>
											<IconDownload />
										</div>
									</div>
								</div>
							</>
						}
						{!isBuildex && !orgList.dataSharingUrl && !orgList.enrolmentQUrl &&
							<div className="details-card-content">
								<div className="details--title">
									No files uploaded yet
								</div>
							</div>
						}
					</div>

					{/* User details card */}
					<div className="--users-list-card">
						<div className="card-wrapper">
							<div className="-card-header">
								<div className="--left-section">
									<div className="DS__svg__icon--fill">
										<IconUsers />
									</div>
									<div className="--title-container">
										<div className="--title">
											{constants.Users} (
											{`${userBackupList?.length ?? ''}`})
										</div>
									</div>
								</div>
								<div className="--right-section">
									<div className="--status-tag--right">
										<button onClick={handleViewAndAddUsers}>
											<IconPlus />
											<span style={{ marginLeft: rem(10) }}>
												{constants.BTN_Add_New_User}
											</span>
										</button>
									</div>
								</div>
							</div>
							<div className="search-box-container">
								<InputSuffixIcon
									placeholder={constants.Search}
									icon={<IconSearch />}
									value={userSearchValue}
									onChange={(e) => setUserSearchValue(e?.target.value)}
								/>
							</div>
							{userSearchedList?.map((userInfo, index) => {
								if (index < 5) {
									return (
										<div key={userInfo?.email} className="-card-content">
											<div className="--left-section width-85">
												<div className="DS__svg__icon--fill">
													<IconUser style={{ verticalAlign: "top" }} />
												</div>
												<div className="--title-container users-card-content">
													<div className="--title">
														{userInfo?.email}
													</div>
													<div className="--subtitle">
														{userInfo?.roles}
														<span className="--subtitle-right">
															{userInfo?.created}
														</span>
													</div>
												</div>
											</div>
										</div>
									);
								} else return null;
							})}
							<div className="-card-content">
								<div className="--left-section width-85">
									<span className="view-all-btn"
										data-testid="view-all-btn"
										onClick={() => handleViewAndAddUsers()}
										onKeyDown={(e) => {
											if (e.key === 'Enter' || e.key === ' '){
												handleViewAndAddUsers();
											}
										}}
										tabIndex="0"
										role="button"
										aria-label="View All Users"
									>
										{constants.View_all}
									</span>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div className="-section">
					{/* System details card */}
					<div className="--systems-list-card">
						<div className="card-wrapper">
							<div className="-card-header">
								<div className="--left-section">
									<div className="DS__svg__icon--fill">
										<IconSettings />
									</div>

									<div className="--title-container">
										<div className="--title">
											{constants.Systems}
										</div>
									</div>
								</div>

								{/*  DO NOT DELETE, might need later... */}

								{/* <div className="--right-section">
									<div className="--status-tag--right card-toggle-switch">
										<label className="switch">
											<input type="checkbox" />
											<span className="slider round"></span>
										</label>
										<span>
											{
												constants.TOGGLE_Disable_Participant_Access
											}
										</span>
									</div>
								</div> */}
							</div>
							{systemsList?.map((system) => {
								return (
									<div className="-card-content" key={system?.systemId}>
										<div className="--left-section width-45">
											<div className="--avatar-icon"
												style={{ backgroundImage: `url(${system?.iconUrl})` }}>
											</div>

											<div className="--title-container systems-card-content">
												<div className="--title system-title">
													{system?.systemName}
												</div>
											</div>
										</div>
										<div className="--right-section width-55">
											{/* <div className="--details-right">
												Providing and Consuming
											</div> */}
											<div className="--status-tag--right">
												{system?.status && <span className="btn-right">
													{system?.status}
												</span>}
											</div>
										</div>
									</div>
								);
							})}
						</div>
					</div>

					{/* Use Cases details card */}
					{!isBuildex && <div className="--use-cases-list-card">
						{orgList.status === "APPROVED"
							&&
							<div className="card-wrapper">
								<div className="-card-header">
									<div className="--left-section">
										<div className="DS__svg__icon--fill">
										<IconUseCase />
										</div>
										<div className="--title-container">
											<div className="--title">
												{constants.Use_Cases}
											</div>
										</div>
									</div>
									<div className="--right-section">
										<div className="--status-tag--right">
											<button onClick={() => goTo(`/admin/use-cases/${participantData?.id}/personas`, participantData)}>
												<IconPlus />
												<span style={{ marginLeft: rem(10) }}>{constants.BTN_Assign_New_Use_Case}</span>

											</button>
										</div>
									</div>
								</div>

								<UseCaseContent itemData={useCaseList || []} />
							</div>}

					</div>}
				</div>
			</div>

		</>
	);
};

export default ParticipantDashboard;
